import { GetAllBones, BoneSide } from "@project-rouge/rg-core";
import { Vector3 } from "three";
import { BoneToVector } from "./index50.js";
import { getInnerMuscles } from "./index226.js";
import { Side } from "./index242.js";
import { ThreadData } from "./index197.js";
function getThreadsFromBuilding(building, context) {
  var _a;
  const bones = GetAllBones(building.data.anatomy);
  const threads = bones.map((b) => getThreadFromBone(b, context));
  for (let i = 0; i < bones.length; i++) {
    const prevBone = bones[i];
    const nextBone = prevBone.joints[1].bones.find((b) => b !== prevBone);
    if (!nextBone)
      continue;
    const nextIndex = bones.indexOf(nextBone);
    const prevThread = threads[i];
    const nextThread = threads[nextIndex];
    prevThread.endThread = { thread: nextThread, right: false };
    nextThread.startThread = { thread: prevThread, right: false };
  }
  for (let i = 0; i < threads.length; i++) {
    const prevThread = threads[i];
    const nextThread = (_a = prevThread.endThread) == null ? void 0 : _a.thread;
    if (!nextThread)
      continue;
    nextThread.start.addScaledVector(nextThread.dir, prevThread.depth);
  }
  return threads;
}
function getThreadFromBone(bone, context) {
  let load;
  if (bone.muscles.length === 1) {
    if (bone.muscles[0].side === BoneSide.Left)
      load = Side.left;
    else
      load = Side.right;
  }
  const dir = BoneToVector(bone).normalize();
  const start = new Vector3().fromArray(bone.joints[0].pos);
  const thread = new ThreadData({
    load,
    start,
    dir,
    boundary: [],
    holes: [],
    context
  });
  thread.end.fromArray(bone.joints[1].pos);
  const prevBone = bone.joints[0].bones.find((b) => b !== bone);
  const nextBone = bone.joints[1].bones.find((b) => b !== bone);
  if (prevBone) {
    const diff = getInnerMuscles(bone, prevBone)[1] ? context.singleBigSide : context.singleSmallSide;
    thread.start.addScaledVector(thread.dir, -diff);
  }
  if (nextBone) {
    const diff = getInnerMuscles(bone, nextBone)[1] ? context.singleBigSide : context.singleSmallSide;
    thread.end.addScaledVector(thread.dir, diff);
  }
  return thread;
}
export {
  getThreadsFromBuilding
};
//# sourceMappingURL=index194.js.map
